import axios from 'axios';

export async function init({ commit, dispatch }) {
	await dispatch('getHistory');
	await dispatch('getVehicles');
	commit('INIT');
}

export async function getVehicles({ commit }) {
	const { data } = await axios.get('/vehicle');
	commit('SET_VEHICLES', data);
}

export async function removeVehicle({ commit }, vehicle) {
	commit('REMOVE_VEHICLE', vehicle);
}

export async function insertVehicle({ commit }, vehicle) {
	commit('INSERT_VEHICLE', vehicle);
}

export async function updateVehicle({ commit }, vehicle) {
	commit('UPDATE_VEHICLE', vehicle);
}

export async function importVehicles(_, type) {
	await axios.get(`/vehicle/import/${type}`);
}

export async function getHistory({ commit }) {
	const { data } = await axios.get('/vehicle/history');
	commit('SET_HISTORY', data);
}

let timeout;
export async function setImportNotification({ commit }, msg) {
	clearTimeout(timeout);
	commit('SET_IMPORT_NOTIFICATION', msg);
	timeout = setTimeout(() => {
		commit('SET_IMPORT_NOTIFICATION', null);
	}, 30000);
}

export async function setImportProgress({ commit }, progress) {
	commit('SET_IMPORT_PROGRESS', progress);
}
